import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=216bc436&"
import script from "./ssoLogin.vue?vue&type=script&lang=ts&"
export * from "./ssoLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports